import type { NpcMenu } from "./types";

/**
 * What the menu a click on one of the world's people opens lists, in the
 * order it lists it. Asked for on 2026-10-05: "Make clicking an NPC provide
 * options like starting quests, vendor, etc".
 *
 * Quests first, since they are what a player walks across the map for, each
 * marked with a "!"; then Trade for somebody who keeps a shop; then the rest
 * of what they will talk about, in their own table's order; and Look last,
 * as on the player menu. An "ask" carries the topic's place in the server's
 * list, which is what the server answers by, so the reordering here never
 * changes which question is put.
 *
 * A quest the character has finished (done, the places of those topics on
 * the menu) is a quest no longer: no "!", and among the rest of the topics
 * in table order (2026-10-08: "when a quest is done, remove the ! from the
 * context menu"), marked with a tick instead (2026-10-08: "when a quest is
 * complete, show a tick on the item in the npc dialoges"). It is still
 * there to ask, and is answered as it was.
 */
export type NpcEntry =
  | { kind: "ask"; label: string; quest: boolean; done: boolean; topic: number }
  | { kind: "trade"; label: string }
  | { kind: "look"; label: string };

export function npcEntries(menu: NpcMenu | undefined, done?: ReadonlySet<number>): NpcEntry[] {
  const topics = (menu?.topics ?? []).map((t, topic) => {
    const finished = !!t.quest && !!done?.has(topic);
    const quest = !!t.quest && !finished;
    const label = quest ? `! ${t.label}` : finished ? `✓ ${t.label}` : t.label;
    return { kind: "ask" as const, label, quest, done: finished, topic };
  });
  const out: NpcEntry[] = topics.filter((t) => t.quest);
  if (menu?.shop) out.push({ kind: "trade", label: "Trade" });
  out.push(...topics.filter((t) => !t.quest));
  out.push({ kind: "look", label: "Look" });
  return out;
}
